/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { useEffect } from '@wordpress/element';
import { InnerBlocks, useSetting, __experimentalFontFamilyControl as FontFamilyControl } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { compose } from '@wordpress/compose';
import { withDispatch, select } from '@wordpress/data';

import Inspector from './inspector';
import { updateBlockStyle } from './inline-styles';
import BlockAppenderButton from '../../components/BlockAppenderButton';

const Edit = ( props ) => {
	useEffect( () => {
		updateBlockStyle( {}, props );
	}, [] );

	const wrapperClasses = classnames(
		className,
		`gutenify-block-faq-wrapper`,
	);
	const {
		isSelected,
		className,
	} = props;
	// const blockLevelFontFamilies = useSetting( 'typography.fontFamilies' );
	return <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } /> }
		{ /* <FontFamilyControl
			fontFamilies={ blockLevelFontFamilies }
			value={ 'fontFamily' }
		/> */ }
		<InnerBlocks
			allowedBlocks={ [ 'gutenify/content-toggle-item' ] }
			renderAppender={ () => {
				return <BlockAppenderButton { ...props } label={ __( '+ Add Faq' ) } />;
			} }
		/>
	</div>;
};

export default compose( [
	withDispatch( ( dispatch, props ) => {
		const { clientId } = props;

		return {
			updateInnerBlocks( initialOpenAll, initialOpenFirst ) {
				const children = select( 'core/block-editor' ).getBlocksByClientId( clientId )[ 0 ].innerBlocks;
				children.forEach( function( child, index ) {
					if ( 'gutenify/content-toggle-item' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, {
							initialOpen: 0 === index ? initialOpenFirst : initialOpenAll,
						} );
					}
				} );
			},
		};
	} ),
] )( Edit );

